export const locale = {
  defaultPlaceholder: 'Choose a position...'
};
